// extracted by mini-css-extract-plugin
module.exports = {"active":"collapse-module--active--2W4Y2","card":"collapse-module--card--wxAet","myAccountWrapper":"collapse-module--myAccountWrapper--1iFwu"};